import { css } from 'emotion'

export const marginLeftSmallestStyles = css`
  margin-left: 4px;
`
